import React from 'react';
import {Stack} from '@mui/material';
import {Button, Icon, Tooltip, IconName} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import {calculateVideoTokensForAssets} from '@/views/content-studio/components/utils';
import {SelectedAsset} from '@/stores/contentStudioStore';

function ManyToManySubmitButton({
  selectedAssets,
  selectedOptions,
  verb,
  noun,
  iconName,
  onClick,
  disabled,
  isLoading,
  bottonTooltip,
}: {
  selectedAssets: SelectedAsset[];
  selectedOptions: number;
  verb: string;
  noun: string;
  iconName: IconName;
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  bottonTooltip?: string;
}) {
  const credits =
    calculateVideoTokensForAssets(selectedAssets) * selectedOptions;

  const getTooltipTitle = () => {
    const creditsText = translate(
      'Each video file up to 30 seconds = 1 credit.'
    );
    const fileCount = selectedAssets.length;
    const optionCount = selectedOptions;

    if (fileCount === 0 && optionCount > 0) {
      return `${creditsText} ${translate('options_only', {
        count: optionCount,
        optionName: noun,
      })}`;
    }

    if (fileCount > 0 && optionCount === 0) {
      return `${creditsText} ${translate('files_only', {
        count: fileCount,
        optionName: noun,
      })}`;
    }

    if (fileCount > 0 && optionCount > 0) {
      const fileText = translate('file_selection', {count: fileCount});
      const optionText = translate('option_selection', {
        count: optionCount,
        optionName: noun,
      });
      return `${creditsText} ${fileText} ${optionText}`;
    }

    return `${creditsText} ${translate('empty_file_empty_options', {
      optionName: noun,
    })}`;
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing="6px"
      justifyContent="flex-end"
      marginTop="auto"
      marginBottom="60px"
    >
      <Tooltip arrow type="light" placement="top" title={bottonTooltip}>
        <div>
          <Button
            onClick={onClick}
            appearance="neutral"
            mode="filled"
            size="large"
            icon={
              <Icon
                name={iconName}
                size="large"
                appearance={disabled ? 'disabled' : 'white'}
              />
            }
            iconPosition="end"
            sx={{
              paddingX: '36px',
              paddingY: '16px',
            }}
            disabled={disabled}
            isLoading={isLoading}
          >
            {translate(verb)}
          </Button>
        </div>
      </Tooltip>
    </Stack>
  );
}

export default ManyToManySubmitButton;
